<template>
  <div>
    <VideoOverlay :assets-loaded="assetsLoaded" />

    <!-- Home page Implementation -->
    <HomeSectionWrapper
      v-for="(item, key) in homePageSections"
      :id="key"
      :key="item.title"
      :title="item.title"
      :subtitle="item.description"
      :preview-src="
        item.previewSrc && `/homePageVideoAssets/${locale}/${isMobile ? 'mobile' : 'desktop'}/${item.previewSrc}.mp4`
      "
      :explain-src="
        item.explanationSrc &&
        `/homePageVideoAssets/${locale}/${isMobile ? 'mobile' : 'desktop'}/${item.explanationSrc}.mp4`
      "
      :assets-loaded="assetsLoaded"
    >
      <div class="slot-wrapper"><component :is="slotComponents[key]" /></div>
    </HomeSectionWrapper>
  </div>
</template>

<script lang="ts" setup>
import { HomePageSections, homePageSections } from '~/utils/constants/home';
import { loadBlob } from '~/utils/constants/preloadBlob';
const { locale } = useI18n();
const { isMobile } = useDevice();
const slotComponents = {
  [HomePageSections.BLOCKCHAIN]: resolveComponent('HomeBlockchainStats'),
  [HomePageSections.CRAFTING]: null,
  [HomePageSections.FARMING]: resolveComponent('HomeFarming'),
  [HomePageSections.REFERRAL]: null,
  [HomePageSections.SEASON]: resolveComponent('HomeSeasonStats')
};
const assetsLoaded = ref(false);

onMounted(async () => {
  const videoAssets = import.meta.glob('./assets/homePageVideoAssets/**/*.mp4', { eager: true }) as Record<
    string,
    { default: string }
  >;
  const videoPromises = Object.values(videoAssets)
    .map((videoSrc) => loadBlob(videoSrc.default))
    .concat(loadBlob('assets/video/desktop-bg.mp4'))
    .concat(loadBlob('assets/video/mobile-bg.mp4'));
  await Promise.allSettled(videoPromises);

  assetsLoaded.value = true;
});
</script>

<style lang="scss" scoped>
.slot-wrapper {
  width: 100%;
}
</style>
